export default __webpack_public_path__ + "static/moog-messenger-logo-1a7b36e424096d7c8edd52e5d764e05b.svg";